import * as featureUtils from '../../utils/featureService';

app.service('featureService', [
  function () {
    this.hasFeature = featureUtils.hasFeature;
    this.hasBetaFeature = featureUtils.hasBetaFeature;
    this.hasRolloutFeature = featureUtils.hasRolloutFeature;
    this.getSetting = featureUtils.getSetting;
    this.getBasePlan = featureUtils.getBasePlan;
  },
]);
